import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';
import { i18n } from 'core/localization';
import { AntAlert } from 'controls/react/ant/antAlert';
import { ApplicationState } from 'framework/applicationState';
import { OAuthValidationNoticeProps } from 'areas/administration/authentication/types';
import { renderText } from './utils';

export const OAuthValidationNotice = observer(({ store }: OAuthValidationNoticeProps) => {
	const notice = store.currentNotice;
	if (!notice?.text) {
		return null;
	}

	return (
		<AntAlert
			type={notice.type}
			showIcon={true}
			title={
				<>
					{renderText(notice)}
					{notice.expires != null &&
						' ' +
							i18n('Code expires', moment(notice.expires).format(ApplicationState.momentDateTimeFormat))}
				</>
			}
		/>
	);
});
